module.exports = __webpack_public_path__ + "static/media/13.895294e4.jpeg";